'use strict';
var BASWebServices;
(function (BASWebServices) {
    var WebappReplace = (function () {
        function WebappReplace() {
        }
        WebappReplace.Factory = function () {
            return function (input) {
                if (angular.isArray(input)) {
                    var filtered = [];
                    angular.forEach(input, function (url) {
                        filtered.push(WebappReplace.replaceWebapp(url));
                    });
                    return filtered;
                }
                else if (angular.isString(input)) {
                    return WebappReplace.replaceWebapp(input);
                }
                else if (input === 'undefined') {
                    return 0;
                }
                else {
                    return input;
                }
            };
        };
        WebappReplace.replaceWebapp = function (inputString) {
            return inputString.replace("clarin", "webapp");
        };
        return WebappReplace;
    }());
    BASWebServices.WebappReplace = WebappReplace;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=WebappReplace.js.map